module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description"}}')
  delete Component.options._Ctor
}
